import { from } from 'rxjs';
import i18next from 'i18next';
import { entityFactoryCreator } from 'web-app/react/entities/factory';
import { dispatchStatusMessageEvent } from '@famly/stat_ts-utils_global-messages';
import { defaultSuccessDuration } from 'web-app/react/global-event/helpers/constants';
import { lazyDispatch } from 'signin-app/redux/helpers';
import RESTClient from 'signin-app/api/clients/rest-client';
import ENV from 'signin-app/config/environment';
const onEntityCreated = (entityName) => {
    dispatchStatusMessageEvent({
        message: i18next.t($ => $.entities.createSuccess, { entityName }),
        statusType: 'Success',
        sticky: false,
        e2eId: '',
        duration: defaultSuccessDuration,
    });
};
const onEntityDeleted = (entityName) => {
    dispatchStatusMessageEvent({
        message: i18next.t($ => $.entities.deleteSuccess, { entityName }),
        statusType: 'Success',
        sticky: false,
        e2eId: '',
        duration: defaultSuccessDuration,
    });
};
const confirmDelete = (msg) => from(new Promise(resolve => {
    // eslint-disable-next-line no-alert
    const isConfirmed = confirm(msg);
    if (isConfirmed) {
        resolve(1);
    }
    else {
        resolve(0);
    }
}));
const entity = entityFactoryCreator(lazyDispatch, ENV.isDevelopment, onEntityCreated, onEntityDeleted, RESTClient, confirmDelete);
export default entity;
